const initialState = {
  loggedIn: false,
  submitting: false,
  redirect: '',
  user: {}
};

export function authentication (state = initialState, action) {
  switch (action.type) {
    case 'SET_USER_FROM_SESSION':
      return {
        ...state,
        loggedIn: true,
        user: action.user,
        redirect: '/home'
      };
    case 'SET_REDIRECT':
      return {
        ...state,
        redirect: action.redirect
      };
    case 'CLEAR_REDIRECT':
      return {
        ...state,
        redirect: ''
      };
    case 'SIGNUP_REQUEST':
      return {
        ...state,
        submitting: true,
        user: action.user
      };
    case 'SIGNUP_SUCCESS':
      return {
        ...state,
        loggedIn: true,
        submitting: false,
        showWelcomeModal: true,
        user: action.user
      };
    case 'SIGNUP_FAILURE':
      return {
        ...state,
        submitting: false,
        errorMessage: action.errorMessage
      };
    case 'LOGIN_REQUEST':
      return {
        ...state,
        submitting: true,
        user: action.user
      };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        loggedIn: true,
        submitting: false,
        redirect: '/home',
        user: action.user
      };
    case 'NEW_PASSWORD_REQUIRED':
      return {
        ...state,
        loggedIn: false,
        submitting: false,
        redirect: '/change-password',
        user: action.user
      };
    case 'LOGIN_FAILURE':
      return {
        ...state,
        submitting: false,
        errorMessage: action.errorMessage
      };
    case 'LOGOUT':
      return {
        ...state,
        loggedIn: false,
        redirect: '/login',
        user: {}
      };
    case 'FORGOT_PASSWORD_REQUEST':
      return {
        ...state,
        submitting: true
      };
    case 'FORGOT_PASSWORD_SUCCESS':
      return {
        ...state,
        submitting: false,
        forgotPasswordEmail: action.forgotPasswordEmail,
        redirect: '/forgot-password'
      };
    case 'FORGOT_PASSWORD_FAILURE':
      return {
        ...state,
        submitting: false,
        errorMessage: action.errorMessage
      };
    case 'FORGOT_PASSWORD_SUBMIT_REQUEST':
      return {
        ...state,
        submitting: true,
        user: action.user
      };
    case 'FORGOT_PASSWORD_SUBMIT_SUCCESS':
      return {
        ...state,
        loggedIn: true,
        submitting: false,
        redirect: '/scheduling',
        user: action.user
      };
    case 'FORGOT_PASSWORD_SUBMIT_FAILURE':
      return {
        ...state,
        submitting: false,
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
}
